(function ($) {
    function pauseClickHandler() {
        $('.ticker_pause_wrapper').addClass('btn_hide');
        $('.ticker_play_wrapper').removeClass('btn_hide');

        $('.ticker_new').addClass('stop_tikcer');

        $('.ticker-video').trigger('pause');
        $('#tickerplay').focus();
    }

    function playClickHandler() {
        $('.ticker_play_wrapper').addClass('btn_hide');
        $('.ticker_pause_wrapper').removeClass('btn_hide');

        $('.ticker_new').removeClass('stop_tikcer');
        $('.ticker-video').trigger('play');
        $('#tickerpause').focus();
    }

    function customAnimationDuration() {
        if ($(".ticker_Collection")) {
            $(".ticker_list").each(function () {
                var AnimationDurationMobile = $(this).attr("data-animationSpeed-mobile");
                var AnimationDurationDesktop = $(this).attr("data-animationSpeed-desktop");
                if (AnimationDurationMobile && AnimationDurationDesktop) {
                    var screenWidth = $(window).width();
                    if (screenWidth < 556) {
                        $(this).css("animation-duration", AnimationDurationMobile);
                    }
                    else {
                        $(this).css("animation-duration", AnimationDurationDesktop);
                    }
                }
            });
        }
    }

    function initLazyLoadForVideos() {
        const videos = document.querySelectorAll("video.ticker-video");

        const lazyLoadVideo = (video) => {
            if (video.getAttribute('data-src')) {
                video.src = video.getAttribute('data-src');
                video.removeAttribute('data-src');
            }
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    lazyLoadVideo(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        });

        videos.forEach(video => {
            observer.observe(video);
        });
    }

    $(document).ready(function () {
        //ticker video lazy load
        initLazyLoadForVideos();

        customAnimationDuration();

        $('.ticker_pause_wrapper').click(function (e) {
            pauseClickHandler();
        });

        $('.ticker_play_wrapper').click(function (e) {
            playClickHandler();
        });

        $('.ticker_pause_wrapper').on("keydown", function (event) {
            e.preventDefault();
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                pauseClickHandler();
            }
        });

        $('.ticker_play_wrapper').on("keydown", function (event) {
            e.preventDefault();
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                playClickHandler();
            }
        });
    });

    $(window).resize(function () {
        customAnimationDuration();
    });
})(window.jQuery);

// GA for social link navigation
analytics.eventConfig.push(
    {
        "target": ".ticker_Collection",
        "codeId": "ticker",
        "events": [
            {
                "eventTarget": ".ticker_social_link a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "si",
                    "componentName": "social icon",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "social icon",
                    "event": "outbound",
                    "eventType": "social icon outbound click",
                    "parentName": "",
                }
            },
            {
                "eventTarget": ".ticker_social_link a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "si",
                    "componentName": "social icon",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "social icon",
                    "event": "navigation",
                    "eventType": "social icon internal navigation click",
                    "parentName": "",
                }
            },
            {
                "eventTarget": ".ticker_btn button",
                "eventType": "click",
                "tags": {
                    "componentId": "si",
                    "componentName": "social icon",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "social icon",
                    "event": "video",
                    "eventType": [
                        {
                            "rule": "$(context).hasClass('ticker_pause_wrapper')==1",
                            "value": "social ticker pause button click"
                        },
                        {
                            "rule": "$(context).hasClass('ticker_play_wrapper')==1",
                            "value": "social ticker play button click"
                        },
                    ],
                    "parentName": "",
                }
            },
        ]
    },
);